export const AUTH_CONFIG = {
  domain: 'apptwist.auth0.com',
  clientId: 'QDDXFmiZBN5zGdp1FTQfits19i8OsqXk',
  loginPath: 'login',
  logoutPath: 'logout',
  responseType: 'token id_token',
  scope: 'openid',
};
